module.exports = __webpack_public_path__ + "img/AminMusa-nologo.81a5a296.png";